export default __webpack_public_path__ + "static/media/RGOne.677041b5.jpg";